/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_LocationInputs */

const fr_legal_privacy_location = /** @type {(inputs: Legal_Privacy_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géolocalisation approximative (précise à la ville près)`)
};

const en_legal_privacy_location = /** @type {(inputs: Legal_Privacy_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approximate geolocation (city-level precision)`)
};

/**
* | output |
* | --- |
* | "Approximate geolocation (city-level precision)" |
*
* @param {Legal_Privacy_LocationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_location = /** @type {((inputs?: Legal_Privacy_LocationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_LocationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_location(inputs)
	return en_legal_privacy_location(inputs)
});